import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import StickyNotesApp from './apps/StickyNotes/StickyNotesApp';
import KanbanItApp from './apps/KanbanIt/KanbanItApp';
import PriorityMatrixApp from './apps/PriorityMatrix/PriorityMatrixApp';
import BrainBreakApp from './apps/BrainBreak/BrainBreakApp';

import TaskBlink from './apps/TaskBlink/TaskBlink';
import WhiteboardItApp from './apps/WhiteboardIt/WhiteboardItApp';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/sticky-notes" element={<StickyNotesApp />} />
        <Route path="/kanban-it" element={<KanbanItApp />} />
        <Route path="/prioritize-it" element={<PriorityMatrixApp />} />
        <Route path="/whiteboard-it" element={<WhiteboardItApp />} />
        <Route path="/brain-break" element={<BrainBreakApp />} />
        <Route path="/to-do" element={<TaskBlink />} />
      </Routes>
    </Router>
  );
}

export default App;
